import React, { useState } from "react";
import { format } from "date-fns";

interface CustomCalendarProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  minDate?: Date; // Add minDate prop
}

const CustomCalendar: React.FC<CustomCalendarProps> = ({
  selectedDate,
  onDateChange,
  minDate,
}) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const startOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1
  );
  const endOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0
  );
  const startDay = startOfMonth.getDay();
  const daysInMonth = endOfMonth.getDate();

  const prevMonth = () =>
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1)
    );
  const nextMonth = () =>
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1)
    );

  const renderDays = () => {
    const days = [];
    for (let i = 0; i < startDay; i++) {
      days.push(<div key={`empty-${i}`} className="text-center py-2" />);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth(),
        i
      );
      const isSelected =
        format(date, "yyyy-MM-dd") === format(selectedDate, "yyyy-MM-dd");
      const isDisabled = minDate && date.getTime() < minDate.getTime();
      days.push(
        <div
          key={i}
          className={`w-10 h-10 flex items-center justify-center rounded-full text-sm ${
            isDisabled
              ? "text-gray-400 cursor-not-allowed"
              : isSelected
              ? "bg-cyan-600 text-white cursor-pointer"
              : "text-gray-700 hover:bg-cyan-100 cursor-pointer"
          }`}
          onClick={() => {
            if (!isDisabled) {
              onDateChange(date);
            }
          }}
        >
          {i}
        </div>
      );
    }
    return days;
  };

  return (
    <div
      className="bg-white shadow-[0px_2px_20px_0px_#0000001F] border-t border-[#E4E4E4] rounded-[10.56px] p-[15.09px] w-full h-full"
      style={{ boxSizing: "border-box" }}
    >
      <div className="flex items-center justify-between mb-4">
        <button onClick={prevMonth}>
          <span className="text-2xl">«</span>
        </button>
        <span className="font-medium">{format(currentMonth, "MMM yyyy")}</span>
        <button onClick={nextMonth}>
          <span className="text-2xl">»</span>
        </button>
      </div>

      <div className="grid grid-cols-7 text-xs text-gray-500 mb-2">
        {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((d) => (
          <div key={d} className="text-center">
            {d}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-y-1 text-center">{renderDays()}</div>
    </div>
  );
};

export default CustomCalendar;
